// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Stores a recent activity of a user
 */
export interface UserActivityOutput {
  userId?: unknown;
  timestamp?: unknown;
  activity: unknown;
  courseId?: unknown;
  moduleId?: unknown;
  taskId?: unknown;
  data?: unknown;
}
